export type IDomainOutletState = "open" | "closed" | "pre_order_only" | "busy";

export const OUTLET_STATES = {
  OPEN: "open",
  CLOSED: "closed",
  PRE_ORDER_ONLY: "pre_order_only",
  BUSY: "busy",
};
